import React, { useState, Component, useRef, useEffect } from 'react'
import DatePagination from '../Datepagination/index'
import './Datepagenator.css'
import Moment from 'moment'

const DatesPaginator = ({ dt, dm, ds, budget_type, date, tab, t,ye,nd,open,setopen }) => {
  const [activePage, setActivePage] = useState()
  const [selectedDate, setSelectedDate] = useState(parseInt(ye)==new Date().getFullYear()?new Date():new Date(ye,new Date().getMonth(),new Date().getDate()))

  const moment = require('moment');


  const handledatechange=(e)=>{
    setSelectedDate(e)
    nd(false)
  }
  
    useEffect(() => {
      setSelectedDate(parseInt(ye) === new Date().getFullYear()? new Date(): new Date(ye, new Date().getMonth(), new Date().getDate()));
    }, [ye]);
      console.log(selectedDate,ye,'data123')
  useEffect(() => {
    if (t) {
      setActivePage(parseInt(t))
      {
        console.log(dt, 'dei im dt')
      }
    }
  }, [t])
  var arr = new Array()
  var rt = moment.utc();
  let daysArray

  useEffect(() => {
    if (budget_type === 1) {
    } else {
      getCalenderdate()
      dm(selectedDate.getMonth() + 1)
      ds(selectedDate.getFullYear())
      dt(selectedDate.getDate())
    }
  }, [selectedDate, budget_type])

  const getCalenderdate = () => {
    if (daysArray.length > 0) {
      daysArray.map((item, i) => {
        if (Moment(item.date).format("YYYY-MM-DD").toString() == Moment(selectedDate).format("YYYY-MM-DD").toString()) {
          setActivePage(i + 1)
          return;
        }
      })
    }
  }
  const Dateref = useRef(null)

  useEffect(() => {
    daysArray.map((x, index) => {
      console.log(x, 'x vlue')
      if (
        Moment(x.date).format('YYYY-MM-DD') ==
        Moment(new Date()).format('YYYY-MM-DD')
      )
      {  setActivePage(index + 1)}
      else if( Moment(x.date).format('YYYY-MM-DD') == Moment(new Date().setFullYear(ye)).format('YYYY-MM-DD')){
        {  setActivePage(index + 1)}
      }
    })
  }, [tab,ye, budget_type])

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        Dateref.current &&
        !event.target.className.toString().includes('react-datepicker')
      ) {
        console.log(
          event.target.className.toString().includes('react-datepicker'),
          'datedbyref'
        )
        setopen(false)
      }
    }
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [open])

  const handlePageChange = pageNumber => {


if(!open){
  nd(false)
}




    console.log('pageNumber:', pageNumber)
    setActivePage(pageNumber)

    const s = Moment(daysArray[pageNumber - 1].date).format('YYYY-MM-DD')
    const date = s.split('-')

    dt(date[2])
    dm(date[1])
    ds(date[0])
  }

  var startDate
  var endDate

  if (budget_type === 1) {
    startDate = new Date('2024-01-01')

    endDate = new Date('2024-01-28')
  }  else{
      // startDate = new Date(`2024-01-01`); 
 
      // endDate = new Date(`2024-12-31`);

       startDate = moment.utc('2024-01-01T00:00:00');
       endDate = moment.utc('2024-12-31T00:00:00');
     
      
      
      } 

     
  var getDateArray = function (start, end) {

    console.log(start, end,"datechc")
  
   



console.log(end,"kjkj")
   
    var i = 0;
    while (start <= end)
      {
      i++;

      if (moment(start)==moment(rt)) {
        setActivePage(i);
    }

      

      arr.push({ date: moment.utc(start) });

      start.add(1, 'days');
    }
    console.log(arr, "fordatafound")
    return arr;
  }


  daysArray = getDateArray(startDate, endDate);
  console.log(daysArray, "daysArray")


 
  return (
    <div className='datepaginator'>
      {daysArray.length && (
        <DatePagination
          activePage={activePage}
          itemsCountPerPage={1}
          totalItemsCount={arr.length > 0 ? arr.length : 1}
          days={arr.length > 0 ? arr : []}
          pageRangeDisplayed={7}
          onChange={handlePageChange}
          setSelectedDate={handledatechange}
          itemClass='item213'
          activeClass='asdf'
          DateRef={Dateref}
          open={open}
          setopen={setopen}
          budget_type={budget_type}
        />
      )}
    </div>
  )
}

export default DatesPaginator
